import { render, staticRenderFns } from "./IconProfile.vue?vue&type=template&id=a768755a&"
import script from "./IconProfile.vue?vue&type=script&lang=js&"
export * from "./IconProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a768755a')) {
      api.createRecord('a768755a', component.options)
    } else {
      api.reload('a768755a', component.options)
    }
    module.hot.accept("./IconProfile.vue?vue&type=template&id=a768755a&", function () {
      api.rerender('a768755a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconProfile.vue"
export default component.exports